/**
 * GraphQL Query
 * カラーマスタ画面
 */

/**
 * カラーマスタ一覧
 */
export const GRAPH_QL_QUERY_PRODUCT_COLOR_LIST =
`
  query {
    colorListItems ( ? ) {
      edges {
        node {
          id
          isActive
          displayOrder
          name
          code
          colorGroupItems {
            groupCode
          }
        }
      }
      totalCount
    }
  }
`

/**
 * カラーマスタ
 */
export const GRAPH_QL_QUERY_COLOR_MASTER =
`
  query {
    colors {
      code
      name
    }
  }
`

/**
 * カラーグループマスタ一覧
 */
export const GRAPH_QL_QUERY_PRODUCT_COLORGROUP_LIST =
`
  query {
    colorGroupListItems ( ? ) {
      edges {
        node {
          id
          isActive
          displayOrder
          name
          code
          colorGroupItems {
            id
            uuid
            isActive
            displayOrder
            groupCode
            code
            name
            skuExists
          }
          productExists
        }
      }
      totalCount
    }
  }
`

/**
 * サイズマスタ一覧
 */
export const GRAPH_QL_QUERY_PRODUCT_SIZE_LIST =
`
  query {
    sizeListItems ( ? ) {
      edges {
        node {
          id
          isActive
          displayOrder
          name
          code
          sizeGroupItems {
            groupCode
          }
        }
      }
      totalCount
    }
  }
`

/**
 * サイズマスタ
 */
export const GRAPH_QL_QUERY_SIZE_MASTER =
`
  query {
    sizes {
      code
      name
    }
  }
`

/**
 * サイズグループマスタ一覧
 */
export const GRAPH_QL_QUERY_PRODUCT_SIZEGROUP_LIST =
`
  query {
    sizeGroupListItems ( ? ) {
      edges {
        node {
          id
          isActive
          displayOrder
          name
          code
          sizeGroupItems {
            id
            uuid
            isActive
            displayOrder
            groupCode
            code
            name
            skuExists
          }
          productExists
        }
      }
      totalCount
    }
  }
`
